export class MyConversion {
  toCamelCase = (str) => {
    const s =
      str &&
      str
        .match(
          /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
        )
        .map((x) => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase())
        .join("");

    return s;
  };
}

export function getCurrencySymbol(region) {
  if (region === "INR") {
    return "₹";
  }
  return "$";
}
